import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["week", "dayRow", "day", "task", "empty", "similarChip", "completedChip", "inProgressChip"]
  static values = {
    selectedWeek: String,
    selectedDay: String,
    similarOnly: Boolean,
    completedOnly: Boolean,
    inProgressOnly: Boolean
  }

  select({ params: { week } }) {
    this.selectedDayValue = ""
    this.selectedWeekValue = String(week)
  }

  selectDay({ params: { day } }) {
    this.selectedDayValue = this.selectedDayValue === day ? "" : day
  }

  toggleSimilar() {
    this.similarOnlyValue = !this.similarOnlyValue
  }

  toggleCompleted() {
    this.completedOnlyValue = !this.completedOnlyValue
  }

  toggleInProgress() {
    this.inProgressOnlyValue = !this.inProgressOnlyValue
  }

  selectedWeekValueChanged() {
    this.applyFilters()
  }

  selectedDayValueChanged() {
    this.applyFilters()
  }

  similarOnlyValueChanged() {
    this.updateChipState(this.similarChipTarget, this.similarOnlyValue)
    this.applyFilters()
  }

  completedOnlyValueChanged() {
    this.updateChipState(this.completedChipTarget, this.completedOnlyValue)
    this.applyFilters()
  }

  inProgressOnlyValueChanged() {
    this.updateChipState(this.inProgressChipTarget, this.inProgressOnlyValue)
    this.applyFilters()
  }

  applyFilters() {
    this.weekTargets.forEach((week) => {
      this.updateChipState(week, week.dataset.week === this.selectedWeekValue)
    })

    this.dayRowTargets.forEach((row) => {
      row.classList.toggle("hidden", row.dataset.week !== this.selectedWeekValue)
    })

    this.dayTargets.forEach((day) => {
      const selected = day.dataset.date === this.selectedDayValue
      this.updateChipState(day.querySelector("[data-day-circle]"), selected)

      const dot = day.querySelector("[data-day-dot]")
      if (dot) {
        dot.classList.toggle("bg-white", selected)
        dot.classList.toggle("bg-indigo-500", !selected)
      }
    })

    const anyChipActive = this.similarOnlyValue || this.completedOnlyValue || this.inProgressOnlyValue
    let visibleCount = 0
    this.taskTargets.forEach((task) => {
      const chipMatches = !anyChipActive ||
        (this.similarOnlyValue && task.dataset.similar === "true") ||
        (this.completedOnlyValue && task.dataset.status === "finished") ||
        (this.inProgressOnlyValue && task.dataset.status === "in_progress")
      const dayMatches = !this.selectedDayValue || task.dataset.date === this.selectedDayValue
      const visible = task.dataset.week === this.selectedWeekValue && dayMatches && chipMatches
      task.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }

  updateChipState(chip, isOn) {
    const onClasses = chip.dataset.onClasses.split(" ")
    const offClasses = chip.dataset.offClasses.split(" ")
    chip.classList.remove(...(isOn ? offClasses : onClasses))
    chip.classList.add(...(isOn ? onClasses : offClasses))
  }
}
